
const NewmeTabularDataRetailerCell = ({ trend, retailerKey, time, company }) => {

  return <div className="w-full h-full flex flex-wrap justify-center ">
    <p className="w-full shrink-0 text-center">{trend[company + 'retailerTimeCount'] && trend[company + 'retailerTimeCount'][retailerKey] ? trend[company + 'retailerTimeCount'][retailerKey] : 0} products</p>
    {trend.brandCounts ? trend.brandCounts.map(b => b.count > 0 ? <p className="text-center font-semibold  w-full shrink-0 " key={b.brand}>{b.count} {b.brand} Products </p> : null) : null}
    {trend[company + 'retailerImages'] ? trend[company + 'retailerImages'].filter(img => new Date(img.insertDate) >= time).slice(0, 4).map(image => <div className="w-28 h-48 p-0.5 flex justify-center items-start max-w-[50%]" key={image.pk}>
      <img src={image.imageUrl} className='max-w-full max-h-full object-contain' loading="lazy" />
    </div>) : null}
  </div>
}

export default NewmeTabularDataRetailerCell
